import { ComponentType, JSX } from 'react';

import { FeatureFlaggedProps } from '@backstage/core-app-api';

import { useFlag } from '@spotify-confidence/react';
import { Value } from '@spotify-confidence/sdk';

// If we wanna use the original FeatureFlagged component,
// we should re-export it from @backstage/core-app-api
// export { FeatureFlagged } from '@backstage/core-app-api';

export const FeatureFlagged = (props: FeatureFlaggedProps) => {
  const flag = 'with' in props ? props.with : props.without;
  const desired = 'with' in props;
  const isEnabled = useFlag(`${flag}.enabled`, false);

  return <>{isEnabled === desired ? props.children : null}</>;
};

/**
 * Function to split a component based on a feature flag.
 *
 * @param flag The flag that should be resolved
 * @param defaultValue The default value for said flag.
 * @param factory The factory function that will create the component based on the flag value.
 * @returns
 */
export const splitComponent = <
  V extends Value.Struct,
  P extends JSX.IntrinsicAttributes,
>(
  flag: string,
  defaultValue: V,
  factory: (value: V) => ComponentType<P>,
) => {
  return (props: P) => {
    const value = useFlag(flag, defaultValue);
    if (!value) {
      return null;
    }

    const Component = factory(value as V); // TODO check this
    return <Component {...props} />;
  };
};

export const useFeatureFlag = <TDefault extends Value.Struct>(
  flag: string,
  defaultValue: TDefault,
) => {
  return useFlag(flag, defaultValue);
};
